import React from 'react'
import clsx from 'classnames'
import type { FreeTimeSlot } from 'api/api.types'
import styles from './AppointmentForm.module.scss'

type TimeProps = {
  time: FreeTimeSlot[],
  selected: string | null,
  onSelect: (time: string) => void,
}

/** Start time slots; only free ones can be picked */
export const Time: React.FC<TimeProps> = ({ time, onSelect, selected }) => (
  <div className={styles.slotsContainer}>
    {time.map((slot) => (
      <div
        key={slot.time}
        onClick={() => slot.isFree && onSelect(slot.time)}
        className={clsx([styles.slot, { [styles.free]: slot.isFree, [styles.selected]: slot.time === selected }])}
      >
        {slot.time}
      </div>
    ))}
  </div>
)
